import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import TourModal from './components/TourModal';
import HomePage from './components/HomePage';
import ReportsPage from './components/reporting/ReportsPage';
import SessionPage from './components/voting/SessionPage';
import JoinPage from './components/lobby/JoinPage';
import PoliciesPage from './components/PoliciesPage';

export default function App() {
  const [showTour, setShowTour] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem('pp_theme') || 'dark');

  useEffect(() => {
    if (!localStorage.getItem('pp_tour_done')) {
      setShowTour(true);
    }
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('pp_theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  return (
    <AuthProvider>
      <BrowserRouter>
        <Header setShowTour={setShowTour} theme={theme} toggleTheme={toggleTheme} />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/session/:sessionId" element={<SessionPage />} />
          <Route path="/join/:sessionId" element={<JoinPage />} />
          <Route path="/policies" element={<PoliciesPage />} />
        </Routes>
        {showTour && <TourModal onClose={() => setShowTour(false)} />}
      </BrowserRouter>
    </AuthProvider>
  );
}
